var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLongArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#282828",
    fillRule: "evenodd",
    d: "M6.422 16.813c-.125.125-.258.187-.399.187-.14 0-.273-.062-.398-.188L.187 11.375C.063 11.281 0 11.156 0 11s.062-.281.188-.375l5.437-5.438C5.75 5.063 5.883 5 6.023 5c.141 0 .274.062.399.188l.328.328c.125.093.188.218.188.375 0 .156-.063.296-.188.421l-3.938 3.891h17.625c.157 0 .29.055.399.164.11.11.164.242.164.399v.468c0 .157-.055.29-.164.399-.11.11-.242.164-.398.164H2.813l3.937 3.89c.125.126.188.266.188.422 0 .157-.063.282-.188.375l-.328.328z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLongArrowLeft);
export default __webpack_public_path__ + "static/media/long-arrow-left.d6fd766867edac1a9a4bc2ba6a63051d.svg";
export { ForwardRef as ReactComponent };